import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';

export const ResultCircles = observer(({ position = '', color = 'yellow' }) => {
  return (
    <div className={`${isMobile() ? 'mob-h-circle-item' : 'g-t-a-b-ins'} ${position}`}>
      <div className={`${isMobile() ? 'mobile-circle-g' : 'g-top-area-circle'} ${color}`} />
    </div>
  );
});
